/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Form, Col, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useFormContext } from 'react-hook-form';
import { FormLabel } from 'screens/common/dynamicForm/dynamicNormalForm/FormFields/FormLabel';

const PasswordInput = ({ type, name, metadata }) => {
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    formState: { errors }
  } = useFormContext();

  const togglePasswordVisibility = () => setShowPassword(prev => !prev);

  const label =
    metadata?.label || (type === 'password' ? 'Password' : 'Confirm_Password');
  const placeholder = metadata?.placeholder || `Enter ${label}`;

  return (
    <Col>
      <Form.Group as={Col} sm={12} md={12} className="mb-3">
        <div className="d-flex align-items-center">
          <FormLabel
            label={metadata.label}
            required={metadata?.validation?.required}
          />
        </div>

        <InputGroup>
          <Form.Control
            type={showPassword ? 'text' : 'password'}
            placeholder={placeholder}
            isInvalid={!!errors[name]}
            {...register(name)}
          />
          <InputGroup.Text
            onClick={togglePasswordVisibility}
            style={{ cursor: 'pointer' }}
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </InputGroup.Text>
        </InputGroup>
        {errors[name] && (
          <Form.Text className="text-danger"> {errors[name].message}</Form.Text>
        )}
      </Form.Group>
    </Col>
  );
};

export default PasswordInput;
